<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6" offset-lg="3">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Organization information</h4>
          </template>
          <template v-slot:body>
            <div v-if="organization">
              <b-row>
                <b-col>
                  <table>
                    <tr>
                      <td>Organization name:</td>
                      <td>{{ organization.name | notAvailable }}</td>
                    </tr>
                    <tr>
                      <td>Identification number:</td>
                      <td>{{ organization.in | notAvailable }}</td>
                    </tr>
                    <tr>
                      <td>License type:</td>
                      <td>
                        {{
                          organization.organization_settings.tier.name
                            | notAvailable
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Activation date:</td>
                      {{
                        organization.organization_settings.created_at
                          | formatTimestamp
                      }}
                    </tr>
                    <tr>
                      <td>Expiration date:</td>
                      {{
                        organization.organization_settings.valid_till
                          | formatTimestamp
                      }}
                    </tr>
                  </table>
                </b-col>
              </b-row>
              <b-row class="mt-4 mb-4">
                <b-col>
                  <h5>Current license limits</h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <table>
                    <tr>
                      <td>Import limit (No. Of Contacts):</td>
                      <td>
                        {{
                          organization.organization_settings.import_max_contacts
                            | notAvailable
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Campaign limit (No. Of Emails) :</td>
                      <td>
                        {{
                          organization.organization_settings
                            .campaign_max_audience | notAvailable
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>Number of active users:</td>
                      <td>
                        {{
                          organization.organization_settings.max_users
                            | notAvailable
                        }}
                      </td>
                    </tr>
                  </table>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-alert :show="true" variant="primary" class="bg-white mt-4">
                    <div class="iq-alert-text">
                      <h4 class="alert-heading mb-4">License change</h4>
                      <p>
                        The license can be upgraded at any time by sending a
                        request to
                        <a href="mailto:support@omnicrane.com"
                          >support@omnicrane.com</a
                        >. For more details on license comparison, please click
                        <a
                          href="https://www.omnicrane.com/en/price-list#comparision"
                          style="text-decoration: underline"
                          target="_blank"
                          >here</a
                        >.
                      </p>
                    </div>
                  </b-alert>
                </b-col>
              </b-row>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="2" offset-lg="3">
          <router-link to="/organizations">
            <b-button block variant="outline-primary" class="mb-3 mr-1"
              >Back to organizations</b-button
            >
          </router-link>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
import { getAccountSync } from "../../Utils/account";
const GET_ORGANIZATION = gql`
  query myOrganization($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      organization {
        id
        name
        in
        organization_settings {
          id
          valid_till
          created_at
          max_users
          import_max_contacts
          campaign_max_audience
          tier {
            id
            name
            max_users
            import_max_contacts
            campaign_max_audience
          }
        }
      }
    }
  }
`;

export default {
  name: "MyOrganization",
  data() {
    return {
      userId: getAccountSync()?.userId
    };
  },
  apollo: {
    organization() {
      return {
        query: GET_ORGANIZATION,
        variables: {
          userId: this.userId
        },
        update: data => {
          return data.users_by_pk?.organization;
        }
      };
    }
  },
  mounted() {
    core.index();
  }
};
</script>
